import React from "react";
import Chart from "react-apexcharts";
import useYearlyEarnings from "../hooks/useYearlyEarnings";
import "./stickyloder.css";

const EarningsYearlyComparisonChart = () => {
  const { data, isLoading, error, currentYear, previousYear } =
    useYearlyEarnings();

  const months =
    data?.data?.map((item) =>
      new Date(`${currentYear}-${item.month}-01`).toLocaleString("en-GB", {
        month: "short",
      })
    ) || [];

  const currentYearData = data?.data?.map((item) => item.current_year) || [];
  const previousYearData = data?.data?.map((item) => item.previous_year) || [];

  const options = {
    chart: { type: "line", height: 350, toolbar: { show: false } },
    stroke: { curve: "smooth", width: 4 },
    xaxis: { categories: months },
    yaxis: { labels: { formatter: (val) => `£${val.toFixed(2)}` } },
    colors: ["#1E90FF", "#00B894"],
    tooltip: { y: { formatter: (val) => `£${val.toFixed(2)}` } },
  };

  const series = [
    { name: `Current Year (${currentYear})`, data: currentYearData },
    { name: `Previous Year (${previousYear})`, data: previousYearData },
  ];

  if (isLoading)
    return (
      <div className="top-loader">
        <div className="top-loader-bar"></div>
      </div>
    );

  if (error) return <div>Failed to load chart</div>;

  return (
    <div className="card" style={{ borderRadius: "15px", padding: "20px" }}>
      <h4>Earnings Comparison (GBP)</h4>
      <Chart options={options} series={series} type="line" height={350} />
    </div>
  );
};

export default EarningsYearlyComparisonChart;
